import React, { useState, useEffect } from 'react';
import {
  ActionBarAccreditationComp,
  DatatableAccreditation,
  CreateAccreditationComp,
  UploadAccreditationComp,
  EditAccreditationComp,
  DetailAccreditaionComp
} from '../../components/moleculs';
import Modal from 'react-bootstrap/Modal';
import axios from '../../library/axios';
import { MySwal } from '../../library/swal';
import { useLocation } from 'react-router-dom';
import UploadSelfAssesmentComp from '../../components/moleculs/accreditations/upload-self-assesment';
import { validationAccess } from "../../helpers/validationAccess"
import { getModule, setHrefWithSlugHook, } from "../../../src/config/routes/guards/slug";
import { getSlug, } from "../../../src/config/routes/guards/slug";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { logo } from '../../assets';

const AccreditationPage = () => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const [lgShowDetail, setLgShowDetail] = useState(false);
  const [lgShowAdd, setLgShowAdd] = useState(false);
  const [lgShowEdit, setLgShowEdit] = useState(false);
  const [surveys, setsurveys] = useState([]);
  const [survey, setsurvey] = useState({});
  const [role, setRole] = useState('');
  const [lgShowUpload, setLgShowUpload] = useState(false);
  const [lgShowUploadSelfAssesment, setLgShowUploadSelfAssesment] = useState(false);
  const [accreditation, setAccreditation] = useState('')
  const [scoreAccumulation, setScoreAccumulation] = useState({})

  const handleUploadSelfAssesment = (row) => {
    setLgShowUploadSelfAssesment(true);
    setAccreditation(row)
  }

  const handleShowDetail = (row) => {
    setLgShowDetail(true);
    setAccreditation(row)
  }

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      console.log(err.message);
    }
  };

  const handleEdit = (survey) => {
    setsurvey(survey);
    setLgShowEdit(true);
  };

  const handleUpload = (survey) => {
    setsurvey(survey);
    setLgShowUpload(true);
  };

  const fetchData = async () => {
    try {
      const options = {
        url: `/accreditations/list`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      // return false
      setsurveys(data);
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    fetchData();
    fetchOneUser();
    fetchLoginStatus();
  }, []);

  const [search, setSearch] = useState([]);
  const [filterData, setFilterData] = useState([]);

  const handleChangeSearch = (text) => {
    setSearch(text);
  };

  useEffect(() => {
    const result = surveys.filter((item) => {
      let TglMulai = item.TglMulai;
      let TglBerakhir = item.TglBerakhir;
      return TglMulai.concat(TglBerakhir)
        .toLowerCase()
        .match(search.toString().toLowerCase());
    });
    setFilterData(result);
    // eslint-disable-next-line
  }, [search]);

  const handleSyncCapaian = async (row) => {
    try {
      const options = {
        url: `/accreditations/sync-capaian/${row.id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data) {
        MySwal.fire({
          icon: "success",
          title: "Success",
          text: "Successfully Sync Capaian Akreditasi!",
        });
      }
      fetchData()
    } catch (err) {
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: 'Failed Sync Capaian Akreditasi.',
      });
      console.log(err);
    }
  };

  const handleBackfillDocScores = async (row) => {
    const confirm = await MySwal.fire({
      icon: 'warning',
      title: 'Backfill Keterkaitan Dokumen?',
      html:
        'Proses ini akan membuatkan keterkaitan dokumen (document_scores) untuk dokumen lama ' +
        'yang belum memilikinya pada kegiatan akreditasi ini.<br/><br/>' +
        'Aman dijalankan berulang (idempotent). Lanjutkan?',
      showCancelButton: true,
      confirmButtonText: 'Ya, jalankan',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    });

    if (!confirm.isConfirmed) return;

    try {
      MySwal.fire({
        title: 'Memproses...',
        text: 'Mohon tunggu, sedang menjalankan backfill.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => MySwal.showLoading(),
      });

      const options = {
        url: `/doc-scores/backfill/${row.id}`,
        method: 'POST',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);

      MySwal.fire({
        icon: 'success',
        title: 'Backfill Selesai',
        html:
          `Total dokumen: <b>${data?.totalDokumen ?? 0}</b><br/>` +
          `Sudah terkait sebelumnya: <b>${data?.sudahTerkait ?? 0}</b><br/>` +
          `Keterkaitan ditambahkan: <b>${data?.ditambahkan ?? 0}</b>`,
      });
    } catch (err) {
      MySwal.fire({
        icon: 'error',
        title: 'Oops, Error!',
        text: 'Gagal menjalankan backfill keterkaitan dokumen.',
      });
      console.log(err);
    }
  };

  const handleExportAccumulation = async (id) => {
    try {
      const options = {
        url: `/accreditations/recap/${id}`,
        method: "GET",
        headers: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      if (data) {
        const doc = new jsPDF();
        const profile = data.profile;
        const accreditation = data.accreditation;
        const pageWidth = doc.internal.pageSize.getWidth();

        // logo kiri
        doc.addImage(logo, "PNG", 14, 10, 70, 20);

        // judul kanan
        doc.setFontSize(14);
        doc.text("Rekapitulasi Self Assessment", pageWidth - 14, 18, {
          align: "right"
        });

        // posisi awal setelah logo
        let y = 45;

        doc.setFontSize(10);

        const labelX = 14;
        const colonX = 50;
        const valueX = 55;

        doc.text("Kode RS", labelX, y);
        doc.text(":", colonX, y);
        doc.text(`${profile["kodeRs"]}`, valueX, y);
        y += 6;

        doc.text("Nama RS", labelX, y);
        doc.text(":", colonX, y);
        doc.text(`${profile["namaRs"]}`, valueX, y);
        y += 6;

        doc.text("Direktur", labelX, y);
        doc.text(":", colonX, y);
        doc.text(`${profile["direktur"]}`, valueX, y);
        y += 6;

        doc.text("Standar", labelX, y);
        doc.text(":", colonX, y);
        doc.text(`${accreditation["standards_accreditation.Nama"]}`, valueX, y);

        // tabel
        const tableData = data.accumulations.map((item, index) => [
          index + 1,
          item.name,
          item.nilaiBab,
          `${item.persentaseTerisi}%`
        ]);

        autoTable(doc, {
          startY: y + 10,
          head: [["No", "BAB", "Nilai", "Kelengkapan Pengisian"]],
          body: tableData
        });

        doc.save("self-assessment-recap.pdf");
      }
    } catch (err) {
      MySwal.fire({
        icon: 'info',
        title: 'Oops, Error!',
        text: 'Failed Get Chapter Accumulations.',
      });
      console.log(err);
    }
  };

  return (
    <>
      {/*begin::Content*/}
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        {/*begin::Toolbar*/}
        <div className="toolbar" id="kt_toolbar">
          {/*begin::Container*/}
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            {/*begin::Page title*/}
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              {/*begin::Title*/}
              <h1 className="d-flex align-items-center text-dark fw-bolder fs-3 my-1">
                Akreditasi
                {/*begin::Separator*/}
                <span className="h-20px border-gray-200 border-start ms-3 mx-2" />
                {/*end::Separator*/}
                {/*begin::Description*/}
                <small className="text-muted fs-7 fw-bold my-1 ms-1">
                  #SPEAK_VERSI_RS
                </small>
                {/*end::Description*/}
              </h1>
              {/*end::Title*/}
            </div>
            {/*end::Page title*/}
            {/*begin::Actions*/}
            <ActionBarAccreditationComp
              showFormAdd={() => setLgShowAdd(true)}
              role={role}
            />
            {/*end::Actions*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Toolbar*/}
        {/*begin::Post*/}
        <div className="post d-flex flex-column-fluid" id="kt_post">
          {/*begin::Container*/}
          <div id="kt_content_container" className="container-xxl">
            {/*begin::Row*/}
            <div className="row gy-5 g-xl-8">
              {/*begin::Col*/}
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <DatatableAccreditation
                      modules={surveys}
                      search={search}
                      handleShowDetail={handleShowDetail}
                      handleChangeSearch={handleChangeSearch}
                      handleEdit={handleEdit}
                      handleSyncCapaian={handleSyncCapaian}
                      handleUpload={handleUpload}
                      handleUploadSelfAssesment={handleUploadSelfAssesment}
                      handleExportAccumulation={handleExportAccumulation}
                      handleBackfillDocScores={handleBackfillDocScores}
                      role={role}
                    />
                  </div>
                </div>
              </div>
              {/*end::Col*/}
            </div>
            {/*end::Row*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Post*/}
      </div>
      {/*end::Content*/}

      <Modal
        show={lgShowAdd}
        onHide={() => setLgShowAdd(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Tambah Kegiatan Akreditasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CreateAccreditationComp
            close={() => setLgShowAdd(false)}
            fetch={() => fetchData()}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUpload}
        onHide={() => setLgShowUpload(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Rekomendasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadAccreditationComp
            close={() => setLgShowUpload(false)}
            fetch={() => fetchData()}
            accreditation={survey}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowEdit}
        onHide={() => setLgShowEdit(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Ubah Kegiatan Akreditasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <EditAccreditationComp
            close={() => setLgShowEdit(false)}
            fetch={() => fetchData()}
            survey={survey}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowUploadSelfAssesment}
        onHide={() => setLgShowUploadSelfAssesment(false)}
        backdrop="static"
        keyboard={false}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Upload Self Assesment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadSelfAssesmentComp
            close={() => setLgShowUploadSelfAssesment(false)}
            idAccreditation={accreditation}
          />
        </Modal.Body>
      </Modal>

      <Modal
        show={lgShowDetail}
        onHide={() => setLgShowDetail(false)}
        backdrop="static"
        keyboard={false}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Detail Kegiatan Akreditasi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DetailAccreditaionComp
            close={() => setLgShowDetail(false)}
            accreditation={accreditation}
            role={role}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AccreditationPage;
